import { useCappsLandlordApplicantDataWebApiHandler_getApplicantDetails } from '@zg-rentals/ts-capps-client-react-query';

export function useGetApplicant({
  listingAlias,
  applicationId,
  applicantUserId,
}: {
  listingAlias: string;
  applicationId: string;
  applicantUserId: string;
}) {
  return useCappsLandlordApplicantDataWebApiHandler_getApplicantDetails({
    listingAlias,
    applicationId,
    applicantUserId,
  });
}
